export default __webpack_public_path__ + "static/media/B.551b68f3.svg";